import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=6face1d7&scoped=true&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=6face1d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6face1d7",
  null
  
)

export default component.exports